import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "switch__icon" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

import "./Switch.scss";


export default /*#__PURE__*/_defineComponent({
  __name: 'Switch',
  props: {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

let model = _useModel<boolean>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["switch", {'switch--checked' : _unref(model)}]),
    type: "button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) //@ts-ignore
 ? model.value = !_unref(model) : model = !_unref(model)))
  }, _hoisted_2, 2))
}
}

})